import { Controls, Edge, type Node as NodeType, ReactFlow, useReactFlow } from "@xyflow/react";
import React, { useCallback, useEffect, useState } from "react";
import Node from "./Node";

interface LayoutFlowProps {
  nodes: NodeType[];
  edges: Edge[];
}

const nodeTypes = { output: Node };
const MIN_GRAPH_WIDTH = 1024;

export default function LayoutFlow({ nodes, edges }: LayoutFlowProps) {
  const [isSmallDevice, setIsSmallDevice] = useState(false);
  const { fitView } = useReactFlow();

  const handleResize = useCallback(() => {
    setIsSmallDevice(window.innerWidth <= MIN_GRAPH_WIDTH);
    fitView();
  }, [fitView]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  useEffect(() => {
    fitView();
  }, [fitView, nodes, edges]);

  return (
    <div className="h-100 w-100" data-testid="graph">
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        fitView={true}
        className="react-flow"
        panOnScroll={false}
        panOnDrag={isSmallDevice}
        zoomOnDoubleClick={false}
        zoomOnScroll={false}
        zoomOnPinch={false}
        elevateEdgesOnSelect={false}
      >
        {isSmallDevice && <Controls showInteractive={false} />}
      </ReactFlow>
    </div>
  );
}
